import { useFormikContext } from "formik";
import { object } from "yup";
import Button from "react-bootstrap/Button";
import {
  Form,
  MultiSelectInput,
  Password,
  Text,
} from "../../components/Form/Form.tsx";
import { URLS } from "../../../commun/routes.tsx";
import url from "../../module/fetch.tsx";
import { useGet } from "../../components/Fetch/useFetch.tsx";
import { RoleEntity } from "../../Entities/RoleEntity.tsx";
import { requiredArray, requiredString } from "../../module/validators.tsx";
import { ActionBar, PageContent } from "../../components/Elements/Elements.tsx";
import PageTitle from "../../components/Elements/PageTitle/PageTitle.tsx";
import { IconUserPen } from "../../components/Icon/Icon.tsx";

type UtilisateurValue = {
  utilisateurId?: string;
  username?: string;
  listRole?: string[];
  utilisateurPassword?: string;
};

export const getInitialValues = (data: UtilisateurValue) => ({
  username: data?.username ?? null,
  listRole: data?.listRole ?? null,
});

export const validationSchema = object({
  username: requiredString,
  listRole: requiredArray,
});

export const validationSchemaCreate = object({
  username: requiredString,
  listRole: requiredArray,
  utilisateurPassword: requiredString,
});

export const prepareVariables = (
  data: UtilisateurValue,
  values: UtilisateurValue,
) => ({
  utilisateurId: data?.utilisateurId,
  username: values.username,
  listRole: values?.listRole,
  utilisateurPassword: values?.utilisateurPassword,
});

const RoleUtilisateur = ({ isNew = false }: { isNew: boolean }) => {
  const { isSubmitting } = useFormikContext();
  const roles = useGet(url`/api/roles/`);

  return (
    <PageContent>
      <Form>
        <PageTitle
          icon={<IconUserPen />}
          title={
            isNew ? "Création d'un utilisateur" : "Mise à jour d'un utilisateur"
          }
        />
        <br />
        <Text
          label="Identifiant"
          name="username"
          disabled={isSubmitting || !isNew}
        />
        <MultiSelectInput
          label="Rôles"
          name="listRole"
          disabled={isSubmitting}
          options={roles?.data ?? []}
          getOptionValue={(r: RoleEntity) => r.roleId}
          toOptionLabelFunc={(r: RoleEntity) => r.roleLibelle}
          isClearable={false}
        />
        {isNew && (
          <Password
            label="Mot de passe temporaire de l'utilisateur"
            name="utilisateurPassword"
            placeholder="Mot de passe"
          />
        )}
        <ActionBar>
          <Button
            href={URLS.GESTION_UTILISATEURS}
            variant={"primary"}
            className={"rounded-pill m-2 p-2"}
          >
            Retour
          </Button>
          <Button
            type={"submit"}
            variant={"primary-100"}
            className={"rounded-pill m-2 p-2"}
          >
            Valider
          </Button>
        </ActionBar>
      </Form>
    </PageContent>
  );
};

export default RoleUtilisateur;
